// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"de098681","802":"ce90d61e","831":"63ce4707"}[chunkId] + ".chunk.js";
};